import { Link, NavLink } from "react-router-dom";
import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";

const links = [
    { to: "/", label: "Home" },
    { to: "/programs/cps-2026", label: "Climate Power Summit" },
    { to: "/membership", label: "Membership" },
    { to: "/apply", label: "Apply" },
    { to: "/contact", label: "Contact" },
];

export default function Nav() {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 40);
        onScroll();
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="site-nav"
            className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
                scrolled ? "bg-[rgba(6,17,36,0.85)] backdrop-blur-lg" : "bg-transparent"
            }`}
        >
            <div className="hairline-b">
                <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-4 flex items-center justify-between">
                    <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 group">
                        <span className="serif-display text-2xl md:text-3xl text-[var(--ivory)]">Z<span className="text-[var(--gold)]">•</span>SGI</span>
                        <span className="hidden md:block label-mono text-[var(--gold)]">Z Ed School of Global Impact</span>
                    </Link>
                    <nav className="hidden lg:flex items-center gap-8">
                        {links.map((l) => (
                            <NavLink
                                key={l.to}
                                to={l.to}
                                data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, '-')}`}
                                className={({ isActive }) =>
                                    `label-mono transition-colors ${isActive ? "text-[var(--gold)]" : "text-[var(--ivory)] hover:text-[var(--gold)]"}`
                                }
                                end={l.to === "/"}
                            >
                                {l.label}
                            </NavLink>
                        ))}
                    </nav>
                    <button
                        className="lg:hidden text-[var(--ivory)]"
                        data-testid="nav-menu-toggle"
                        onClick={() => setOpen((v) => !v)}
                        aria-label="Toggle menu"
                    >
                        {open ? <X size={22} /> : <Menu size={22} />}
                    </button>
                </div>
            </div>
            {open && (
                <motion.div
                    initial={{ opacity: 0, y: -8 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="lg:hidden bg-[var(--navy-deep)] hairline-b"
                >
                    <div className="px-6 py-6 flex flex-col gap-4">
                        {links.map((l) => (
                            <NavLink
                                key={l.to}
                                to={l.to}
                                onClick={() => setOpen(false)}
                                data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s+/g, '-')}`}
                                className={({ isActive }) =>
                                    `label-mono ${isActive ? "text-[var(--gold)]" : "text-[var(--ivory)]"}`
                                }
                                end={l.to === "/"}
                            >
                                {l.label}
                            </NavLink>
                        ))}
                    </div>
                </motion.div>
            )}
        </header>
    );
}
